// extracted by mini-css-extract-plugin
export default {"wrapper":"FilterTags_wrapper__9-r+4"};